module.exports = __webpack_public_path__ + "img/khandevane.b1f44c6.png";